import styled from "styled-components";

export const SearchSuggestionListStyled = styled.div`
  z-index: 3;
  position: absolute;
  top: 78px;
  right: 36px;
  width: 270px;

  /* max-height: 80%; */
  overflow-y: auto;
  scrollbar-width: thin;

  /* .list-cont {
    transition: 1s;
    visibility: hidden;
    opacity: 0;
  } */
  transition: max-height 1.2s;

  max-height: ${({ selectMapSuggestionsShow }) =>
    !selectMapSuggestionsShow ? "0" : "80%"};
`;
